import { useMemo } from 'react';

import { useSearchContext } from '@jane/search/hooks';
import { buildSearchFilter } from '@jane/search/util';
import type { MenuCategoryPath } from '@jane/shared/types';

import { useComposeMenuFilters } from './useComposeMenuFilters';

export const useMenuAdSearchFilter = (
  menuCategory: MenuCategoryPath | undefined
) => {
  const { searchState } = useSearchContext();

  const filterByCategory =
    !!menuCategory && !['all', 'featured'].includes(menuCategory);

  const staticFilters = useComposeMenuFilters(
    filterByCategory
      ? [`kind:"${menuCategory}" OR root_types:"${menuCategory}"`]
      : []
  );

  const searchFilter = useMemo(
    () =>
      buildSearchFilter({
        searchState: {
          ...searchState,
          filters: { ...searchState?.filters, brand: [] },
        },
        staticFilters,
      }),
    [searchState, staticFilters]
  );

  const pageCategory = filterByCategory ? menuCategory : undefined;

  return { pageCategory, searchFilter };
};
